import React, { useState, useEffect } from 'react';
import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
	Button,
	Image,
	Box,
	Text,
	VStack,
	useBreakpointValue
} from '@chakra-ui/react';

const MessageModel = ({ show, title, description, image, UpdateShowParent }) => {
	const [isOpen, setIsOpen] = useState(false);
	const modalSize = useBreakpointValue({ base: 'full', md: 'lg' });

	useEffect(() => {
		setIsOpen(show);
	}, [show]);

	const handleClose = () => {
		setIsOpen(false);
		if (UpdateShowParent) {
			UpdateShowParent(false);
		}
	};

	if (!isOpen) return null;

	return (
		<Modal isOpen={isOpen} onClose={handleClose} size={modalSize} isCentered>
			<ModalOverlay bg="blackAlpha.600" />
			<ModalContent mx={4}>
				<ModalHeader textAlign="center" fontSize="lg" fontWeight="semibold">
					{title}
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody pb={6}>
					<VStack spacing={4} align="stretch">
						{image && (
							<Box>
								<Image 
									src={image} 
									alt={title} 
									w="100%" 
									borderRadius="md"
									objectFit="cover"
								/>
							</Box>
						)}
						{description && (
							<Box>
								<Text 
									dangerouslySetInnerHTML={{ __html: description }}
									fontSize="sm"
									lineHeight="1.6"
								/>
							</Box>
						)}
						<Box textAlign="center" pt={4}>
							<Button 
								colorScheme="blue" 
								onClick={handleClose}
								size="md"
								minW="100px"
							>
								Close
							</Button>
						</Box>
					</VStack>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
export default MessageModel;
